import { HomeViewProps } from "../types";
import cassioImage from "../../../assets/cassio.jpeg";
import { useTranslation } from "react-i18next";
import { useDocumentTitle } from "../../../hooks/useDocumentTitle";

export function HomeController() {
  const { t } = useTranslation();
  useDocumentTitle(
    t("home:metaTitle", "Cassio Silva Takarada — Software Engineer & AI Researcher"),
    t(
      "home:metaDescription",
      "Full Stack Software Engineer (React, TypeScript, Node.js) and AI researcher. View experience, skills and projects."
    )
  );

  // Dados do perfil com traduções
  const profileData = {
    name: "Cassio Silva Takarada",
    role: t("home:subtitle", "Software Engineer & AI Researcher"),
    description: t(
      "home:description",
      "Software Engineer with over 5 years of experience, specialized in fullstack development (React, TypeScript, Node.js), AI systems, cloud (AWS, Azure) and high test coverage."
    ),
    imageSrc: cassioImage,
    socialLinks: {
      linkedin: "https://www.linkedin.com/in/cassiotakarada/",
      github: "https://github.com/cassiotakarada",
      email: "cassio.takarada@example.com",
      whatsapp: "5511999999999",
    },
    slogan: t("home:slogan", "Coding the future of intelligence"),
    buttonProjects: t("common:viewProjects", "View Projects"),
    buttonContact: t("common:contactMe", "Contact Me"),
    cvUrl: "/assets/cassio-takarada-cv.pdf",
  };
  const viewProps: HomeViewProps = {
    profileData,
  };

  return viewProps;
}

export default HomeController;
